import "./utils/init"
import "./utils/newrelic"

// Initialize Firebase FIRST before any React imports
import { firebaseInit } from "./modules/mp-database/firebaseInit"

// Ensure React is loaded once and early
import React from "react"
import ReactDOM from "react-dom"
import * as serviceWorker from "./serviceWorker"

// Import our simple safe Provider and the Redux store
import { Provider } from "react-redux"

import { store } from "./modules/mp-core/redux/store"

// Import global styles
import "./modules/mp-core/themes/styles/_styles.scss"
import "react-dates/initialize"
import "react-toastify/dist/ReactToastify.css"
import "./scss/App.scss"
import "quill/dist/quill.snow.css"

// Import the App component directly
import App from "./App"

// Router and other components
import { BrowserRouter, Route } from "react-router-dom"
import { ScopedCssBaseline } from "@mui/material"
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles"
import { ManagementTheme } from "./modules/mp-core/themes"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import {
  QueryParamProvider,
  transformSearchStringJsonSafe
} from "use-query-params"

import { reportAccessibility } from "./modules/mp-utils/generic-utils"

import { getCustomHeaders } from "./modules/mp-utils/generic-utils/Headers"
import { attachCloudFunctionAuth } from "./modules/mp-utils/generic-utils/Headers/cloudFunctionAuth"
import axios from "axios"
axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  ...getCustomHeaders()
}
attachCloudFunctionAuth()

// Create options outside of render
const queryStringifyOptions = {
  transformSearchString: transformSearchStringJsonSafe
}

// Simple render function that doesn't use hooks
ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={ManagementTheme}>
      <ScopedCssBaseline>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Provider store={store}>
            <BrowserRouter>
              <QueryParamProvider
                ReactRouterRoute={Route}
                stringifyOptions={queryStringifyOptions}
              >
                <App />
              </QueryParamProvider>
            </BrowserRouter>
          </Provider>
        </LocalizationProvider>
      </ScopedCssBaseline>
    </ThemeProvider>
  </StyledEngineProvider>,
  document.getElementById("root")
)

// Report accessibility
// TODO: lets put this on a feature flag OR an env variable. Including by default kills the system
//reportAccessibility();

// Service worker - unregister() can be changed to register() to enable offline use
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
